@layer components {
  .blob {
    --look-x: 0.35;
    --look-y: 0.25;
    --blob: 2.375rem;

    display: inline-flex;
    flex: none;
    align-items: center;
    justify-content: center;
    gap: calc(var(--blob) * 0.04);
    inline-size: var(--blob);
    block-size: var(--blob);
    padding-block-end: calc(var(--blob) * 0.06);
    border-radius: 50%;
    background:
      radial-gradient(ellipse 30% 20% at 30% 20%, oklch(100% 0 0 / 70%), oklch(100% 0 0 / 0%) 100%),
      var(--color-action);
    box-shadow:
      inset 0 calc(var(--blob) * -0.08) calc(var(--blob) * 0.12) calc(var(--blob) * -0.03)
      var(--color-action-shade),
      0 calc(var(--blob) * 0.1) calc(var(--blob) * 0.22) calc(var(--blob) * -0.08)
      oklch(18% 0.1 257 / 50%);
    transition:
      scale var(--duration-spring) var(--ease-spring),
      rotate var(--duration-spring) var(--ease-spring);

    &[data-size="lg"] {
      --blob: 6.5rem;
    }

    &[data-mood="alert"] {
      scale: 1.08;
    }

    &[data-mood="happy"] {
      animation: hop 640ms var(--ease-out);
    }
  }

  @keyframes hop {
    0% {
      translate: 0 0;
      scale: 1;
    }
    18% {
      scale: 1.08 0.9;
    }
    52% {
      translate: 0 calc(var(--blob) * -0.22);
      scale: 0.96 1.06;
    }
    78% {
      translate: 0 0;
      scale: 1.06 0.94;
    }
    100% {
      translate: 0 0;
      scale: 1;
    }
  }

  .eye {
    position: relative;
    display: block;
    inline-size: calc(var(--blob) * 0.36);
    block-size: calc(var(--blob) * 0.4);
    border: calc(var(--blob) * 0.035) solid var(--sticker-ink);
    border-radius: 50%;
    background: oklch(100% 0 0);
    clip-path: inset(0 0 0 0);
    animation: blink 5.6s ease-in-out infinite;
    transition:
      scale 120ms var(--ease-out),
      translate 160ms var(--ease-out),
      clip-path 160ms var(--ease-out),
      border-width 160ms var(--ease-out),
      background-color 120ms var(--ease-out);

    .blob[data-mood="alert"] & {
      animation: none;
      scale: 1.12 1.22;
    }

    /* The eye closes upward into the top half of its own rim: a ∩ smile. */
    .blob[data-mood="happy"] &,
    .blob[data-mood="wink"] &:last-child {
      animation: none;
      border-width: calc(var(--blob) * 0.06);
      background: transparent;
      clip-path: inset(0 0 50% 0);
      translate: 0 12%;
    }
  }

  @keyframes blink {
    0%,
    93.5%,
    100% {
      scale: 1 1;
    }
    95.5%,
    97.5% {
      scale: 1 0.1;
    }
  }

  .pupil {
    position: absolute;
    inset-block-start: 50%;
    inset-inline-start: 50%;
    inline-size: 52%;
    block-size: 48%;
    border-radius: 50%;
    background: var(--sticker-ink);
    translate: calc(-50% + var(--look-x) * 42%) calc(-50% + var(--look-y) * 42%);
    transition:
      translate 260ms var(--ease-out),
      scale 200ms var(--ease-out),
      opacity 120ms var(--ease-out);

    &::after {
      content: "";
      position: absolute;
      inset-block-start: 18%;
      inset-inline-start: 22%;
      inline-size: 30%;
      block-size: 30%;
      border-radius: 50%;
      background: oklch(100% 0 0 / 90%);
    }

    .blob:not([data-follow]) & {
      animation: glance 6s var(--ease-out) infinite;
    }

    .blob[data-mood="alert"] & {
      animation: none;
      scale: 1.25;
      translate: -50% calc(-50% + 0.5 * 42%);
    }

    .blob[data-mood="happy"] &,
    .blob[data-mood="wink"] .eye:last-child & {
      opacity: 0;
    }
  }

  @keyframes glance {
    0%,
    30% {
      translate: calc(-50% + 0.45 * 42%) calc(-50% + 0.2 * 42%);
    }
    38%,
    62% {
      translate: calc(-50% - 0.5 * 42%) calc(-50% + 0.15 * 42%);
    }
    70%,
    100% {
      translate: calc(-50% + 0.45 * 42%) calc(-50% + 0.2 * 42%);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .eye,
    .blob[data-mood="happy"] {
      animation: none;
    }

    .pupil,
    .blob:not([data-follow]) .pupil {
      animation: none;
      transition: none;
    }
  }
}
